<template>
  <div class="order-item">
    <div class="order-item_content">
      <div class="order-item_subTitle">
        <span>{{ categoryTimeName }}</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "SummerOrderItem",
    props: {
      categoryTimeName: {
        type: String,
        required: true
      }
    },
    created() {
    },
    methods: {}
  };

</script>

<style lang="less" scoped>

  .order-item {
    padding: 10px;
    cursor: pointer;
    border: 1px solid #f5efef;
    border-radius: 5px;
    margin-bottom: 5px;

    &_image {
      height: 100%;
      border: 1px solid #9e9e9e82;
      border-radius: 5px;
      margin-right: 1%;
    }

    &_content {
      display: inline-block;
    }

    &_title {
      margin: 10px 0;
    }

    &_subTitle {
      color: @regular-text-color;
    }

    &_subTitle span {
      font-size: 12px;
    }

    &_major {
      white-space: pre-line;
      font-size: 14px;
      color: @secondary-text-color;
      .text-overflow-visible-line(2);
      text-overflow: clip;
    }

    &_major span {
      display: inline-block;
      height: 25px;
      padding: 0 5px;
      margin: 3px;
      line-height: 23px;
      font-size: 12px;
      border-width: 1px;
      border-style: solid;
      border-radius: 4px;
      box-sizing: border-box;
      background-color: #f4f4f5;
      border-color: #e9e9eb;
      color: #909399;
    }

    &_desc {
      white-space: pre-line;
      font-size: 14px;
      color: @secondary-text-color;
      .text-overflow-visible-line(2);
      text-overflow: clip;
    }

    &:hover {
      border-radius: 3px;
      background: #fff;
      box-shadow: 0 10px 30px 0 rgba(136, 150, 171, 0.15);
    }
  }

</style>
